import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseActionsComponent } from '@shared/components/base-actions/base-actions.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { ControlActionsService } from '@shared/services/control-actions.service';

@Component({
  selector: 'app-tc-actions',
  templateUrl: './tc-actions.component.html',
  styleUrls: ['./tc-actions.component.scss'],
  imports: [
     FormsModule, NgSelectModule, TranslateModule, WCAGLabelDirective, CommonModule],
})
export class TcActionsComponent extends BaseActionsComponent implements OnInit {

  @Input() tcData: any;
  @Input() actionsList: any[] = [];
  @Output() successfullAction = new EventEmitter<boolean>();

  constructor(private controlActionsService: ControlActionsService,
  ) {
    super();
  }

  ngOnInit() {
    this.actionsList.forEach(
      option => (option.workflowAction = this.translateService.instant(`COMMON.actionsLabel.${option.workflowAction}`)),
    );
  }

  public triggerActionController(value: any): void {
    this.resetSelection();
    this.tcData.action = value.action as any;

    // this.controlActionsService.documentDoAction(this.tcData).subscribe(data => {
    //   this.successfullAction.emit(true);
    // });
  }
}
